import axios from 'axios';

export interface User {
  _id: string;
  name: string;
  email: string;
  isActive: boolean;
}

const API_URL = `${process.env.REACT_APP_API_URL}/users`;

// الحصول على جميع المستخدمين
export const getUsers = async (): Promise<User[]> => {
  try {
    console.log('Fetching users from API:', API_URL);
    const response = await axios.get(API_URL);
    console.log('Users API response status:', response.status);
    console.log('Users API response data structure:', response.data ? Object.keys(response.data) : 'null');
    
    // التعامل مع هيكل الاستجابة المختلف حيث يتم تضمين المستخدمين في خاصية 'users'
    if (response.data && response.data.users && Array.isArray(response.data.users)) {
      console.log(`Found ${response.data.users.length} users in response.data.users`);
      return response.data.users;
    }
    
    // التعامل مع الاستجابة كمصفوفة مباشرة (إذا تغير API في المستقبل)
    if (response.data && Array.isArray(response.data)) {
      console.log(`Found ${response.data.length} users in direct array response`);
      return response.data;
    }
    
    console.error('API response does not contain a valid users array:', response.data);
    return [];
  } catch (error) {
    console.error('Error fetching users:', error);
    return [];
  }
};

// الحصول على مستخدم محدد
export const getUserById = async (id: string): Promise<User> => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

// البحث عن مستخدمين
export const searchUsers = async (query: string): Promise<User[]> => {
  const response = await axios.get(`${API_URL}/search?query=${query}`);
  return response.data;
};

// الحصول على المستخدمين النشطين فقط
export const getActiveUsers = async (): Promise<User[]> => {
  const response = await axios.get(`${API_URL}/active`);
  return response.data;
};